module.exports = __webpack_public_path__ + "img/Stemness-CRC_GSE206552.7ed1b251.png";